import React from "react";

const Footer = () => {
  const date = new Date();

  const year = date.getFullYear();

  return (
    <div className="bg-222226 w-full">
      <div className="2xl:container w-full h-12 flex justify-center items-center">
        <p className="text-white text-16 font-medium">
          Copyright © {year} Transforma. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
